import React from 'react';
import { DataVizContainer } from '../common/DataVizContainer';
import {
  TimePeriodUnsegmentedVizConfig,
  TimePeriodUnsegmentedVizExternalProps,
  TimePeriodUnsegmentedVizViews,
} from './types';
import { useTimePeriodUnsegmentedConfigToData } from './useConfigToData';
import { timePeriodUnsegmentedViewConfigs } from './views/view-configs';

export interface TimePeriodUnsegmentedVizProps {
  dataConfig: TimePeriodUnsegmentedVizConfig;
  selectedView: TimePeriodUnsegmentedVizViews;
  externalProps: TimePeriodUnsegmentedVizExternalProps;
  persistenceKey: string;
}

export const TimePeriodUnsegmentedViz = (
  props: TimePeriodUnsegmentedVizProps
) => {
  const externalPropsWithSelectedView: TimePeriodUnsegmentedVizExternalProps = {
    ...props.externalProps,
    selectedView: props.selectedView,
  };
  return (
    <DataVizContainer
      dataConfig={props.dataConfig}
      externalProps={externalPropsWithSelectedView}
      useConfigToData={useTimePeriodUnsegmentedConfigToData}
      selectedView={props.selectedView}
      viewConfigs={timePeriodUnsegmentedViewConfigs}
      persistenceKey={props.persistenceKey}
    />
  );
};
